module.exports = __webpack_public_path__ + "static/media/0019.7a2d5d5d.jpg";